import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import store from '@/store'

Vue.use(VueI18n)

const messages = {
  zh,
  en
}

const i18n = new VueI18n({
  locale: store.state.lang || 'zh',
  fallbackLocale: 'zh',
  messages
})

// watch the state to sync the locale when it changes
store.watch(
  state => state.lang,
  newLang => {
    i18n.locale = newLang
  }
)

export default i18n
